import React from "react";
import { FaCheckCircle, FaCrown, FaStar, FaPhoneAlt } from "react-icons/fa";
import { Container } from "./PlansCard.styles";

const PlansCard = ({ plan, price, screen, isPopular = false, features = [] }) => {
  return (
    <Container className={isPopular ? "popular-card" : ""}>
      {isPopular && (
        <div className="popular-badge">
          <FaStar /> Most Popular
        </div>
      )}
      <div className="card_header">
        <div className="plan-icon">
          <FaCrown />
        </div>
        <h3 className="plan-name">{plan}</h3>
        <span className="screen-tag">{screen} {screen === "1" ? "Screen" : "Screens"}</span>
      </div>

      <div className="card_body">
        <div className="price-wrap">
          <span className="currency">$</span>
          <span className="price-num">{price}</span>
          <span className="period">/mo</span>
        </div>
        <p className="billing-note">Billed monthly &bull; No contracts</p>

        <ul className="plan-features">
          {features.map((feat, idx) => (
            <li key={idx} className={feat.included ? "" : "disabled-feature"}>
              <FaCheckCircle className="check" />
              <span>{feat.text}</span>
            </li>
          ))}
        </ul>

        <a
          href="tel:6823860871"
          className="subs-btn"
          title="Call (682) 386-0871 to get started"
        >
          <FaPhoneAlt style={{ marginRight: "6px", fontSize: "12px" }} /> Get Started
        </a>
      </div>
    </Container>
  );
};

export default PlansCard;
